import { LOGIN_SOURCES } from '../types/paramsConfig.js';
const loginSourceLabelsMapping = {
    [LOGIN_SOURCES.INTERVIEW_COACH]: 'interviewCoach',
    [LOGIN_SOURCES.SALARY]: 'salary',
    [LOGIN_SOURCES.CV_TO_JOB_FIT]: 'cvToJobFit',
    [LOGIN_SOURCES.SEARCH_ASSISTANT]: 'searchAssistant',
    [LOGIN_SOURCES.HOMEPAGE_LOGIN_WALL]: 'homepage_onLoad',
};
const loginSourceTranslation = (label, loginSource, translationFunction, params) => {
    if (loginSourceLabelsMapping[loginSource] === undefined) {
        return null;
    }
    try {
        if (loginSource) {
            const labelWithLoginSource = `loginregistration.${[
                loginSourceLabelsMapping[loginSource],
            ]}.${label}`;
            const loginSourceSpecificLabel = translationFunction(labelWithLoginSource, { ...params });
            return loginSourceSpecificLabel === labelWithLoginSource
                ? null
                : loginSourceSpecificLabel;
        }
    }
    catch (e) {
        return null;
    }
    return null;
};
export const useTranslatedSourceOverrideLabel = (loginSource, translationFunction) => (label, params) => {
    return (loginSourceTranslation(label, loginSource, translationFunction, params) ??
        translationFunction(`loginregistration.${label}`, { ...params }));
};
//# sourceMappingURL=useTranslatedLabel.js.map